import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReportFilterReport016Service {

  constructor() {
  }

  static generate(filters: any, afilters: any[]): void {
    if (filters.itemType !== undefined) //
      afilters.push({
        field: 'tipoPeca',
        value: '' + filters.itemType,
        matchMode: 'equals'
      });

    if (filters.actionComunication !== undefined) //
      afilters.push({
        field: 'acaoComunicacao',
        value: '' + filters.actionComunication,
        matchMode: 'equals'
      });
  }

}
